import { LitElement, html, css } from 'lit'
import { consume } from '@lit/context'
import { isOutletNavigationOpenContext, isSubMenuOpenContext } from './context.ts'
import { customElement } from 'lit/decorators.js'
import { TW } from '../../shared'

const TwLitElement = TW(LitElement)

/**
 * Sample Lit Element in assets/lit
 */
@customElement('button-close-menus')
export class ButtonCloseMenus extends TwLitElement {

    @consume({context: isSubMenuOpenContext, subscribe: true})
    private _isSubMenuOpen: boolean = false

    @consume({context: isOutletNavigationOpenContext, subscribe: true})
    private _isOutletNavigationOpen: boolean = false

    static styles = css`
        :host([hidden]) {
            display: none;
        }
    `

    private _isShown() {
        return this._isSubMenuOpen || this._isOutletNavigationOpen
    }

    private _onClick(event: Event) {
        event.preventDefault();
        event.stopPropagation();
        this.dispatchEvent( new CustomEvent( 'bmw-header-close-menus', { bubbles: true, composed: true } ) )
    }

    render() 
    {
        if ( ! this._isShown() ) {
            this.setAttribute( 'hidden', '' );
            return html``
        }

        this.removeAttribute( 'hidden' );

        return html`<div class="wp-block-button is-bmw-icon is-bmw-icon-close-rg"><button @click=${this._onClick} class="wp-element-button block cursor-pointer" aria-label="Menü schließen" aria-expanded="false"></button></div>`
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'button-close-menus': ButtonCloseMenus
    }
}
